@if(patient){
<span>
  {{patient!.nom}} {{patient!.prenom}} ({{patient!.titre}})

  @if (enCoursDeChargement){
  <tui-icon size="s" icon="@tui.circle-dashed" />
  } @else {
  @if (patient!.telesuivi?.observanceList){
  <tui-icon size="s" icon="@tui.monitor" />
  }
  }

  @if(activite){
  <tui-chip appearance="primary">{{ activite }}</tui-chip>
  }
</span>

}@else{
<span class="placeholder">
  NOM______ Prénom______ (M.)
  <tui-icon size="s" icon="@tui.circle-dashed" />
</span>
}